export default {
  newsItems: (state) => state.newsItems,
  editingNewsItem: (state) => state.editingNewsItem,
  loading: (state) => state.loading,
  paginator: (state) => state.paginator,
  sort: (state) => state.sort,
};
